module.exports = __webpack_public_path__ + "img/MapPicsBanditHideout.49a86a28.webp";